
import React, { useState, useEffect, useRef, useContext } from 'react';
import banner from 'apis/banner/banner';
import { toast } from "react-toastify";
import Carousel from 'components/Carousel/Carousel';
import Context from 'context/context';
import CarouselSettingsModal from './CarouselSettingsModal';
import settingsApi from 'apis/settings/settings';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Grid from "@material-ui/core/Grid";
import { useTranslation } from 'react-i18next';
import * as moment from 'moment';



const BannerUploader = () => {
  const { state, dispatch } = useContext(Context);
  const { get, upload, update } = banner(); // Make sure update method exists in your API
  const { editSettings } = settingsApi();
  const editRef = useRef(null);
  const currentDate = moment().format('YYYY-MM-DD');
  const [loading, setLoading] = useState(false);
    const { t, i18n } = useTranslation();

  


  const [states, setStates] = useState({
    file: null,
    fileType: '',
    fileName: '',
    type: '',
    status: '',
    coverUrl: '',
    selectedBanner: null,
    bannerList: [],
    isCreateBtnClicked: false,
    startdate: moment().format('YYYY-MM-DD'),
    enddate: "",
    language: 'Both'
  });

  const {
    file,
    fileType,
    fileName,
    type,
    status,
    coverUrl,
    selectedBanner,
    bannerList,
    isCreateBtnClicked,
    startdate,
    enddate,
    language
  } = states;
  

  const [showModal, setShowModal] = useState(false);
  const [carouselSettings, setCarouselSettings] = useState({
    interval: null,
    animationType: '',
  });

  useEffect(() => {
    fetchImages();
  }, []);

  const fetchImages = async () => {
    try {
      const response = await get();
      console.log(response, "response")
      console.log(response?.banner_interval, "response?.banner_interval")
      setStates({ ...states, bannerList: response?.data });
      setCarouselSettings({ interval: response?.bannerInterval, animationType: response?.bannerStyle })
    } catch (error) {
      console.error("Failed to fetch banner images:", error);
    }
  };



  const updateConfig = async () => {
    try {
      let values = {
        banner_interval: carouselSettings.interval,
        banner_style: carouselSettings.animationType
      }
      const response = await editSettings(values);
      if (response) {
        toast.success('Updated Successfully');
      }
    } catch (error) {
      console.error("Failed to fetch banner images:", error);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setStates({
      ...states,
      file: file,
      fileName: file.name,
      fileType: file.type
    });    
  };


  const handleEditClick = () => {
    if (editRef.current) {
      editRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

      // Optional highlight effect
      editRef.current.classList.add("highlight");
      setTimeout(() => {
        editRef.current.classList.remove("highlight");
      }, 1500);
    }
  };

  useEffect(() => {
    handleEditClick();
  }, [isCreateBtnClicked, selectedBanner]);

  const handleBannerClick = (banner) => {
    const { file_name, is_active, cover_url, type, start_date, end_date,language } = banner;
    setStates({
      ...states,
      selectedBanner: banner,
      fileName: file_name,
      status: is_active ? 'true' : 'false',
      coverUrl: cover_url,
      type: type,
      file: null,
      startdate: start_date,
      enddate: end_date,
      language: org === "Henry Schein Canada" ? (language || 'Both') : null
    });
  };
  console.log(bannerList, "banner")
   const LANGUAGE_MAP = {
  en: 'English',
  fr: 'French',
};
console.log(LANGUAGE_MAP,"LANGUAGE_MAP")
  const uiLang = LANGUAGE_MAP[i18n.language];
  console.log(uiLang,"uiLang")
 
  console.log(states?.startdate)
  const handleUpload = async () => {
    if (!file && !selectedBanner) {
      toast.error('No file selected');
      return;
    }
    setLoading(true)
    const formData = new FormData();
    if (file) {
      formData.append('file', file);
      formData.append('fileName', fileName);
      formData.append('fileType', fileType);
      formData.append('type', org == "Henry Schein Canada" ? "THRIVE" : type);
      formData.append('coverUrl', coverUrl);
      formData.append('status', true);
      formData.append('startdate', startdate);
      formData.append('enddate', enddate);
      if (org === "Henry Schein Canada") {
        formData.append('language', states.language);
      }
    }
    try {
      if (selectedBanner) {
     
        if (org === "Henry Schein Canada") {
          const normalize = (val) => val?.toUpperCase();
          const newStatus = status === "true" || status === true;
          const newLanguage = normalize(language);
          const newEndDate = enddate || null;
  
          const simulatedBanners = bannerList.map((b) => {
            if (b.id === selectedBanner.id) {
              return {
                ...b,
                is_active: newStatus,
                language: newLanguage,
                end_date: newEndDate,
              };
            }
            return { ...b, language: normalize(b.language) };
          });
  
          const hasPermanentCoverage = (lang) =>
            simulatedBanners.some((b) => {
              const covers = b.language === lang || b.language === "BOTH";
              return covers && b.is_active === true && !b.end_date;
            });
  
          const missingCoverage = ["ENGLISH", "FRENCH"].filter(
            (lang) => !hasPermanentCoverage(lang)
          );
  
          if (missingCoverage.length > 0) {
            const label = (l) => (l === "ENGLISH" ? "English" : "French");
            toast.error(
              `At least one ${missingCoverage.map(label).join(" and ")} banner must remain active.`
            );
            setLoading(false);
            return;
          }
        }
  
        let values;
        values = {
          id: selectedBanner.id,
          fileName,
          status,
          type: org == "Henry Schein Canada" ? "THRIVE" : type,
          coverUrl,
          startdate,
          enddate,
          language
        };
  
        if (!status) {
          toast.error("Please select the Status");
          setLoading(false)
          return;
        }
  
        if (org == "Henry Schein Dental" && (!type || type == 'Select')) {
          toast.error("Please select the Type");
          setLoading(false)
          return;
        }
  
        if (enddate && moment(startdate).isAfter(moment(enddate))) {
          toast.error("Start date should be less than or equal to End date");
          setLoading(false)
          return;
        }
        if (status && enddate && moment(enddate).isBefore(moment(), 'day')) {
          toast.error("End date is in the past. Please remove the past date or set a future date.");
          setLoading(false);
          return;
        }
        if (startdate?.toString() === "Invalid Date") {
          toast.error("Invalid date.", {
            toastId: "invalid-date",
          });
          setLoading(false)
          return
        }
  
        let ress = await update(values);
        setLoading(false)
        if (ress.type == "error") {
          toast.error(ress.message);
          return;
        }
  
        toast.success("Banner updated successfully");
      } else {
        if (org == "Henry Schein Dental" && (!type || type == 'Select')) {
          toast.error("Please select the Type");
          setLoading(false)
          return;
        }
  
        if (enddate && moment(startdate).isAfter(moment(enddate))) {
          toast.error("Start date should be less than or equal to End date");
          setLoading(false)
          return;
        }
  
        if (startdate?.toString()?.toLowerCase() == "invalid date") {
          toast.error("Invalid date.", {
            toastId: "invalid-date",
          });
          setLoading(false)
          return;
        }
  
        let res = await upload(formData);
        setLoading(false)
  
        if (res.message == "Banner upload successfully") {
          toast.success("Uploaded successfully");
        }
      }
      setTimeout(function () {
        window.location.reload();
      }, 1000);
    } catch (err) {
      console.error('Upload error:', err);
      setLoading(false)
    }
  };

  const handleReset = () => {
    setStates({
      ...states,
      file: null,
      type: '',
      fileName: '',
      fileType: '',
      selectedBanner: null,
      status: '',
      coverUrl: '',
      isCreateBtnClicked: false,
      startdate: moment().format('YYYY-MM-DD'),
      enddate: "",
      language: org === "Henry Schein Canada" ? 'Both' : null
    })
    editRef.current = null;
  };

  const handleOnChange = (key, value) => {
    setStates({ ...states, [key]: value });
  }
  console.log(carouselSettings, "carouselSettings")
  const org = state?.userInfo?.loyalty_organization_name;

  return (
    <div className="banner-uploader">
      <style>{`
        .banner-uploader {
          max-width: 960px;
          margin: 40px auto;
          font-family: sans-serif;
          padding: 0 20px;
        }
        .banners-grid {          
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 20px;
          margin-bottom: 40px;
        }
        .banner-card {
          background: #fff;
                    
          overflow: hidden;
          box-shadow: 0 2px 4px rgba(0,0,0,0.05);
          cursor: pointer;
          transition: transform 0.3s ease;
          padding: 13px;
        }
        .banner-card:hover {
          transform: translateY(-2px);
        }
        .banner-card img {
          width: 100%;
          height: 100px;
          object-fit: cover;
        }
        .form-container {
          background: #fff;
          border: 1px solid #ddd;
          padding: 24px;
          border-radius: 12px;
          box-shadow: 0 4px 10px rgba(0,0,0,0.05);
          transition: background-color 0.5s,
        }
        .drop-area {
          border: 2px dashed #ccc;
          height: 160px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          color: #777;
          cursor: pointer;
          margin-bottom: 16px;
        }
        .form-input,
        .form-textarea,
        select {
          width: 100%;
          padding: 10px 12px;
          border: 1px solid #ccc;
          border-radius: 6px;
          margin-bottom: 16px;
          font-size: 14px;
        }
        .button-group {
          display: flex;
          justify-content: flex-end;
          gap: 10px;
        }
        .btn {
          padding: 8px 16px;
          border: none;
          border-radius: 6px;
          font-size: 14px;
          cursor: pointer;
        }
        .btn.cancel {
          background: #f3f3f3;
          color: #333;
        }
        .btn.upload {
          background: #2563eb;
          color: white;
        }
        .btn:disabled {
          background: #a0aec0;
          cursor: not-allowed;
        }
        .drop-area.disabled {
          background-color: #f9f9f9;
          border-color: #ccc;
          opacity: 0.6;
          pointer-events: none;
          cursor: not-allowed;
        }
      `}</style>

      <div style={{ display: 'flex', justifyContent: "space-between",marginBottom:"10px" }}>
        {/* <h2 className="section-title">Banner Repository & Preview</h2> */}
        <div>
          <button
            style={{ padding: "5px 10px", background: "#0a72ba", cursor: 'pointer', border: "none", borderRadius: 5, color: "#fff", height: 30 }}
            onClick={() => {
              setStates({ ...states, isCreateBtnClicked: true });
            }}
          >
            Upload
          </button>
          <button
            style={{ marginLeft: 5, padding: "5px 10px", background: "#0a72ba", cursor: 'pointer', border: "none", borderRadius: 5, color: "#fff", height: 30 }}
            onClick={() => setShowModal(true)}
          >
            Settings
          </button>
        </div>
      </div>

      <div className="banners-grid">
        <Carousel autoPlay={false} displayArrow={true} animationType='slide'>
          {bannerList.map((banner) => (
            <div key={banner.id} className="banner-card">
              <img src={banner.url} alt={banner.title} style={{ objectFit: 'cover' }} />
              <div className="info">
                <h3><strong>{`File Name: `}</strong>{banner.file_name}</h3>
                <div>
                  <strong>{`Uploaded: `}</strong>
                  {new Date(banner?.updatedAt).toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric'
                  })}
                </div>
                {org == "Henry Schein Dental" && <div>
                  <strong>{`Type: `}</strong>
                  {banner?.type == "THRIVE" ? "Thrive Rewards" : banner?.type == "SIGNATURE" ? "Thrive Signature" : banner?.type == "STARTUP" ? "Thrive Startup" : (banner?.type == "ALL" || banner?.type == "BOTH") ? "All" : banner?.type}
                </div>}
                <div>
                  <strong>{`Start Date: `}</strong><span>{banner?.start_date ? moment(banner?.start_date).format('MM/DD/YYYY') : "-"}</span>
                </div>
                <div>
                  <strong>{`End Date: `}</strong><span>{banner?.end_date ? moment(banner?.end_date).format('MM/DD/YYYY') : "-"}</span>
                </div>
                {org === "Henry Schein Canada" && (
                  <div>
                    <strong>Language: </strong>
                    <span>{banner?.language ? banner.language : '-'}</span>
                  </div>
                )}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <strong>{`Status: `}</strong><span style={banner?.is_active == true ? { color: 'green' } : { color: 'red' }}>{`${banner?.is_active == true ? 'Active' : 'Inactive'}`}</span>
                  </div>

                  <button
                    style={{ padding: "5px 10px", background: "#0a72ba", cursor: 'pointer', border: "none", borderRadius: 5, color: "#fff" }}
                    onClick={() => handleBannerClick(banner)}>
                    Edit
                  </button>
                </div>
              </div>
            </div>
          ))}
        </Carousel>
      </div>

      {(selectedBanner || isCreateBtnClicked) && <div className="form-container" ref={editRef}
        id="edit-section">
        <h2>{selectedBanner ? "Edit Banner" : "Upload New Promotion Banner"}<span style={{ color: 'red' }}>*</span></h2>

        <label htmlFor="file-upload" className={`drop-area ${selectedBanner ? 'disabled' : ''}`}>
          {file ? (
            <img
              src={URL.createObjectURL(file)}
              alt="Preview"
              style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
            />
          ) : selectedBanner ? (
            <img
              src={selectedBanner.url}
              alt="Selected"
              style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
            />
          ) : (
            <div>
              <p>Drag & drop banner image here</p>
              <p style={{ fontSize: '12px', color: '#aaa' }}>or click to browse (JPG, PNG, max 5MB, Resolution (1927x275))</p>
            </div>
          )}
        </label>
        <input
          key={file ? file.name : "default"}
          id="file-upload"
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          style={{ display: 'none' }}
          disabled={!!selectedBanner}
        />

        {org === "Henry Schein Dental" && (
          <>
            <span style={{ marginLeft: "6px" }}>
              {('Select Type')} <span style={{ color: 'red', fontSize: "21px" }}>*</span> :
            </span>

            <select
              className="form-input"
              value={type}
              onChange={(e) => {
                const value = e.target.value;
                handleOnChange('type', value);
              }}
              required
            >
              <option selected>Select</option>
              <option value="THRIVE">Thrive Rewards</option>
              <option value="SIGNATURE">Thrive Signature</option>
              <option value="STARTUP">Thrive Startup</option>
              <option value="ALL">All</option>
            </select>
          </>
        )}
        <span style={{ marginLeft: "6px" }}>{('Redirection Url (Optional)')} : </span>
        <textarea
          className="form-textarea"
          // placeholder="Redirection Url"
          value={coverUrl}
          onChange={(e) => {
            let value = e.target.value;
            handleOnChange('coverUrl', value);
          }}
        />
        {org === "Henry Schein Canada" && (
  <>
    <span style={{ marginLeft: "6px" }}>
      Language <span style={{ color: 'red', fontSize: "21px" }}>*</span> :
    </span>

    <select
      className="form-input"
      value={language}
      onChange={(e) => handleOnChange('language', e.target.value)}
    >
      <option value="Both">Both</option>
      <option value="English">English</option>
      <option value="French">French</option>
    </select>
  </>
)}
        <Grid item xs={8}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <span style={{ marginLeft: "6px" }}>{('Start Date')}<span style={{ color: 'red', fontSize: "21px" }}>*</span>: </span>




              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  disableToolbar
                  inputVariant="outlined"
                  format="MM/dd/yyyy"
                  id="date-picker-inline"
                  style={{ width: "420px", marginBottom: "9px" }}
                  required
                  value={startdate}
                  onChange={(date) => {
                    setStates((prev) => ({
                      ...prev,
                      startdate: moment(date).format('YYYY-MM-DD'),
                    }));
                  }}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  minDate={new Date()}
                  disabled={(selectedBanner && moment(startdate).toDate() < moment().toDate()) ? true : false}
                  helperText=""
                  error={false}
                  autoOk
                />
              </MuiPickersUtilsProvider>
            </div>

            <div style={{ marginTop: "10px" }}>
              <Grid item xs={8}>
                <span style={{ marginLeft: "17px" }}>{('End Date (Optional)')} : </span>
              </Grid>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  disableToolbar
                  inputVariant="outlined"
                  format="MM/dd/yyyy"
                  id="date-picker-inline"
                  style={{ width: "424px", marginBottom: "5px", marginLeft: "9px" }}
                  required
                  value={enddate}
                  onChange={(date) => {
                    setStates((prev) => ({
                      ...prev,
                      enddate: date ? moment(date).format('YYYY-MM-DD') : null,
                    }));
                  }}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  minDate={startdate ? moment(startdate).toDate() < moment().toDate() ? moment().toDate() : moment(startdate).toDate() : moment().toDate()}
                  disabled={!startdate || startdate === "Invalid date"}
                  helperText=""
                  error={false}
                  autoOk
                />
              </MuiPickersUtilsProvider>
            </div>
          </div>

        </Grid>


        {selectedBanner && (
          <>
            <span style={{ marginLeft: "6px" }}>{('Select Status')} <span style={{ color: 'red', fontSize: "21px" }}>*</span>: </span>
            <select
              className="form-input"
              value={status}
              onChange={(e) => {
                let value = e.target.value;
                handleOnChange('status', value);
              }}
            >
              {/* <option value="" disabled hidden>Select Status</option> */}
              <option value={true}>Active</option>
              <option value={false}>Inactive</option>
            </select> </>)}

        <div className="button-group">
          <button className="btn cancel" onClick={() => {
            handleReset();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}>Cancel</button>
          {loading?  <button
            className="btn upload"
          >
             Loading...
          </button>:  <button
            className="btn upload"
            onClick={handleUpload}
            disabled={!file && !selectedBanner}
          >
            {selectedBanner ? "Update Banner" : "Upload Banner"}
          </button>}
        
        </div>
      </div>}

      <CarouselSettingsModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onChange={(key, value) => setCarouselSettings({ ...carouselSettings, [key]: value })}
        props={carouselSettings}
        onSave={updateConfig}
      />
    </div>
  );
};

export default BannerUploader;